<template>
  <div class="lb">
    <div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope40',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '基本水平条形图-scope40',
      timer: null,
      defaultdata: [
        { value1: '1月', value2: '80', value3: '系列一', value4: '' },
        { value1: '2月', value2: '40' },
        { value1: '3月', value2: '62' },
        { value1: '4月', value2: '90' },
        { value1: '5月', value2: '62' },
        { value1: '6月', value2: '60' },
        { value1: '7月', value2: '40' },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
				{ name: '图例', key: 'value3' },
				{ name: '单位', key: 'value4' },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
			let unit = this.defaultdata[0].value4 || ''
      let mydata = this.defaultdata.map((item) => {
        let newitem = {
          name: item.value1,
          value: item.value2,
        };
        return newitem;
      });
      let yAxis = this.defaultdata.map((item) => item.value1);
      const percent = (5 / yAxis.length) * 100;
      const zoom = [
        {
          id: "scope40", // 唯一的id
          yAxisIndex: [0], //滑动条为竖
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        title: [
          {
            text: unit,
            top: "0",
            right: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
              width: 80,
              overflow: 'truncate'
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        // legend: [
        //   {
        //     top: "2%",
        //     right: 50,
        //     itemHeight: 12, //图例的高度  文字左边那个
        //     itemWidth: 10,
        //     icon: 'rect',
        //     textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },

        //     data: ["系列一"]
        //   },
        // ],
        grid: {
          left: "5px",
          right: "10px",
          bottom: "10px",
          top: "20px",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
        },
        yAxis: {
          type: "category",
          // zlevel:10,
          z: 10,
          // max: 4,
          // data: mydata.map(item => item.name),
          data: yAxis,
          axisLabel: {
            interval: 0,
            width: 54,
            overflow: "truncate", //文字超出宽度截断，默认为...
            // overflow: 'break', //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            // formatter: function (value) {
            // 		return value.length > 6 ? value.slice(0, 5) + '...' : value;
            // }
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
              // width: 1,
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
						name: this.defaultdata[0].value3 || "",
            type: "bar",
            stack: "total",
            smooth: true,
            label: {
              show: true,
            },
            // showBackground: true,
            // backgroundStyle: {
            //   color: '#1f2a30'
            // },
            label: {
              // position: [10, 10], //在右显示
              normal: {
                align: "right",
                position: [380, 2],
                show: false, //关闭文字显示
                textStyle: {
                  color: "#bdc2cb",
                  fontSize: 14,
                },
                formatter: function (params) {
                  // console.log(params, '|params|');
                },
              },
            },
            barWidth: 15,
            barGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  1,
                  1,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#00e3e2", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#00e3e2", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#053042", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
            data: mydata,
          },
        ],
      };
      if (yAxis && yAxis.length > 5) {
        Toption.dataZoom = zoom;
      }
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
